export default __webpack_public_path__ + "static/media/gb-wls.fd4e6515.svg";